import { render, staticRenderFns } from "./Climatology.vue?vue&type=template&id=a4266d3c"
import script from "./Climatology.vue?vue&type=script&lang=js"
export * from "./Climatology.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports